import { yupResolver } from '@hookform/resolvers/yup';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

import { VALIDATION_SCHEMAS } from '../../../constants';
import { BasicModal, Button, TextInputController } from '../../Shared';

export const FullnameModal = ({ open, credentials, onSignIn, onClose }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { control, handleSubmit } = useForm({
    resolver: yupResolver(VALIDATION_SCHEMAS.LOGIN_FULL_NAME),
    defaultValues: { fullName: '' },
  });

  const onSubmit = handleSubmit(async data => {
    setIsSubmitting(true);

    try {
      const response = await fetch('/update-full-name', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...credentials, ...data }),
      });

      if (response.status !== 200) throw new Error();

      setIsSubmitting(false);
      onClose();
      onSignIn();
    } catch {
      setIsSubmitting(false);
      toast.error('Something went wrong, please try again!', {
        position: 'top-right',
        autoClose: 3000,
      });
    }
  });

  return (
    <BasicModal open={open} onClose={isSubmitting ? undefined : onClose}>
      <div className="bg-white w-[576px] rounded-2xl shadow-[-40px_40px_80px_-8px_rgba(0,0,0,0.24)]">
        <div className="flex items-center justify-between py-4 pl-5 pr-4 border-b border-b-base-200">
          <span className="text-base-1000 font-semibold text-[22px]/[28px]">
            Full Name
          </span>
          <button
            type="button"
            className="inline-flex h-8 w-8 items-center justify-center rounded-full border border-transparent text-sm font-semibold text-gray-800 transition hover:bg-gray-100 disabled:pointer-events-none disabled:opacity-50 dark:text-white dark:hover:bg-gray-700 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
            data-hs-overlay="#edit-contact-modal"
            onClick={onClose}
            disabled={isSubmitting}
          >
            <span className="sr-only">Close</span>
            <svg
              className="h-4 w-4 flex-shrink-0"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </button>
        </div>
        <div className="py-4 px-5">
          <TextInputController
            control={control}
            name="fullName"
            label="Full Name"
            placeholder="Full Name"
          />
        </div>
        <div className="flex justify-end py-4 px-5 border-t border-t-base-200">
          <Button title="Save" onClick={onSubmit} disabled={isSubmitting} />
        </div>
      </div>
    </BasicModal>
  );
};
